import { StyleSheet } from 'aphrodite';
import constants from '../../../../constants/styles';
let {
  TABLE_TEXT_COLOR,
  TABLE_DATA_BORDER_COLOR,
  TABLE_SELECTED_COLOR,
  BUTTON_WHITE_HOVER_BG_COLOR
} = constants;

let styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    height: 45,
    backgroundColor: TABLE_SELECTED_COLOR,
    borderBottom: `1px solid ${TABLE_DATA_BORDER_COLOR}`,
    boxSizing: 'border-box',
    fontSize: '0.95em',
    textAlign: 'left',
    paddingLeft: 34,
    paddingRight: 20,
    color: TABLE_TEXT_COLOR
  },
  buttons: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto'
  },
  button: {
    background: 'none',
    border: '1px solid',
    fontSize: '0.9em',
    maxHeight: 33,
    boxSizing: 'border-box',
    fontWeight: 400,
    textTransform: 'none',
    marginLeft: 10,
    padding: '5px 20px',
    ':hover': {
      backgroundColor: BUTTON_WHITE_HOVER_BG_COLOR
    }
  },
  history: {
    marginLeft: 20,
    cursor: 'pointer',
    flex: 1,
    textAlign: 'right'
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/components/data/datatable/extendedrow/ExtendedRow.styles.js